<template lang="pug">
  #appConversasPeriodo
    el-card(shadow="hover")
      p.bolder Filtros
      el-row.margin-left
        el-col(:xs="12" :lg="7" :xl ="7" :sm="13")
          InputEntreDatas(
            placeholder="Período"
            :calendario="calendario"
            v-model="calendario"
          )
        el-col(:xs="24" :lg="6" :xl ="8" :sm="11")
          p Status
          el-select(
            v-model="filtro.status"
            multiple
            collapse-tags
            filterable
            clearable
          )
            el-option(
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
        el-col(:xs="24" :lg="9" :xl ="7" :sm="13")
          p Assunto
          el-select(
            style="width: 24rem"
            v-model="filtro.assunto"
            filterable
            clearable
            multiple
            collapse-tags
          )
            el-option(
              v-for="assunto in assuntos"
              :key="assunto.value"
              :label="assunto.label"
              :value="assunto.value"
            )
        el-col(:xs="24" :lg="8" :xl ="6" :sm="11")
          p Responsável
          el-select(
            v-model="filtro.idsResponsaveis"
            multiple
            collapse-tags
            filterable
            clearable
          )
            el-option(
              v-for="item in responsaveis"
              :key="item.pessoa.pessoaFisica.id"
              :label="item.pessoa.pessoaFisica.nome"
              :value="item.pessoa.pessoaFisica.id"
            )
      el-row.margin.float
        el-button(
          type="text"
          size="medium"
          round
          @click="handleLimpar"
        ) Limpar
        el-button(
          type="primary"
          size="medium"
          round
          @click="handleFiltrar"
        ) Filtrar
    el-row.content-dados
      el-tabs(
        type="border-card"
        v-model="activeTab"
        @tab-click="tabSelecionado"
      )
        el-tab-pane(
          v-for="item in tabsPeriodos"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        )
          component(
            :is="item.grafico"
            v-if="activeTab === item.name && acaoCondicao"
            :dadosLabels="item.dados"
          )
          component(
            :is="item.tabela"
            v-if="activeTab === item.name && !acaoCondicao"
            :data="item.dados"
            :colunaChave="nomeColuna"
            :totalDeConversas="item.totalDeConversas"
            emptyData="Não há dados registrados"
          )
      el-row
        BotaoSelecionar.center(
          @btn-0="selecionar('acao-1')"
          @btn-1="selecionar('acao-2')"
          botao0="Gráficos"
          botao1="Tabela"
        )
      el-row.botaoExportar.float
        BotaoExportarSelecionado(
          @exportar-img-grafico="exportarImgGrafico"
          :filtro="filtro"
          :selecionadoCondicao="acaoCondicao"
          :disabled="botaoExportarDesligado"
          :dadosFiltro="filtro"
          :tab="periodo"
          :carregando="isLoading"
        )
</template>

<script>
import { mapActions } from 'vuex'
import domtoimage from 'dom-to-image'
import moment from 'moment'

import AppNotificacao from '@/components/mixins/AppNotificacao'
import InputEntreDatas from '../InputEntreDatas'
import BotaoSelecionar from '../BotaoSelecionar'
import BotaoExportarSelecionado from '../BotaoExportarSelecionado'
import GraficoPeriodoMensal from '../graficos/GraficoPeriodoMensal'
import GraficoPeriodoSemanal from '../graficos/GraficoPeriodoSemanal'
import GraficoPeriodoDiario from '../graficos/GraficoPeriodoDiario'
import AppListagemConversas from '../AppListagemConversas'
import { assuntos, status } from './nomesEstaticos'

export default {
  name: 'AppConversasStatus',
  mixins: [
    AppNotificacao
  ],
  components: {
    InputEntreDatas,
    BotaoSelecionar,
    BotaoExportarSelecionado
  },
  data () {
    return {
      nomeColuna: 'Período',
      acaoCondicao: true,
      calendario: [],
      status: [],
      assuntos: [],
      responsaveis: [],
      botaoExportarDesligado: false,
      isLoading: false,
      activeTab: 'MENSAL',
      periodo: 'periodoMensal',
      tabsPeriodos: {
        abaMensal: {
          label: 'Mensal',
          name: 'MENSAL',
          grafico: GraficoPeriodoMensal,
          tabela: AppListagemConversas,
          dados: [],
          totalDeConversas: 0
        },
        abaSemanal: {
          label: 'Semanal',
          name: 'SEMANAL',
          grafico: GraficoPeriodoSemanal,
          tabela: AppListagemConversas,
          dados: [],
          totalDeConversas: 0
        },
        abaDiario: {
          label: 'Diário',
          name: 'DIARIO',
          grafico: GraficoPeriodoDiario,
          tabela: AppListagemConversas,
          dados: [],
          totalDeConversas: 0
        }
      },
      mensal: null,
      semanal: null,
      diario: null,
      filtro: {
        dataInicio: null,
        dataFim: null,
        status: [],
        assunto: [],
        idsResponsaveis: []
      },
      totalDeConversas: 0,
      totalFiltrado: 0,
      colunasTabela: [
        { key: 'PERIODO', label: 'Período' },
        { key: 'QUANTIDADE', label: 'Quantidade' }
      ],
      tableLoading: false
    }
  },
  methods: {
    ...mapActions({
      findResponsaveis: 'filtros/findResponsaveis',
      filtrarPorPeriodo: 'filtros/filtrarPorPeriodo'
    }),

    selecionar (acao) {
      if (acao === 'acao-1') {
        this.acaoCondicao = true
      } else {
        this.acaoCondicao = false
      }
    },

    exportarImgGrafico () {
      this.isLoading = true
      const dataConsulta = moment().format('DD-MM-YYYY_hh:mm:ss')
      let abaId = 'pane-MENSAL'
      let abaPeriodo = 'Mensal'
      switch (this.activeTab) {
        case 'MENSAL':
          abaId = 'pane-MENSAL'
          abaPeriodo = 'Mensal'
          break
        case 'SEMANAL':
          abaId = 'pane-SEMANAL'
          abaPeriodo = 'Semanal'
          break
        case 'DIARIO':
          abaId = 'pane-DIARIO'
          abaPeriodo = 'Diario'
      }
      domtoimage.toBlob(document.getElementById(`${abaId}`))
        .then(blob => {
          window.saveAs(blob, `Grafico_Período_${abaPeriodo}_${dataConsulta}.png`)
          this.isLoading = false
        })
    },

    seNaoHaDados () {
      if (
        this.tabsPeriodos.abaMensal.dados.every(elem => elem.quantidade === 0) &&
        this.tabsPeriodos.abaSemanal.dados.every(elem => elem.quantidade === 0) &&
        this.tabsPeriodos.abaDiario.dados.every(elem => elem.quantidade === 0)
      ) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Nenhuma conversa encontrada neste período.'
        )
        this.botaoExportarDesligado = true
      } else if (
        this.periodo === 'periodoMensal' &&
        this.tabsPeriodos.abaMensal.dados.every(elem => elem.quantidade === 0)) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Nenhuma conversa encontrada no período mensal.'
        )
        this.botaoExportarDesligado = true
      } else if (
        this.periodo === 'periodoSemanal' &&
        this.tabsPeriodos.abaSemanal.dados.every(elem => elem.quantidade === 0)) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Nenhuma conversa encontrada no período semanal.'
        )
        this.botaoExportarDesligado = true
      } else if (
        this.periodo === 'periodoDiario' &&
        this.tabsPeriodos.abaDiario.dados.every(elem => elem.quantidade === 0)) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Nenhuma conversa encontrada no período diário.'
        )
        this.botaoExportarDesligado = true
      } else {
        this.botaoExportarDesligado = false
      }
    },

    handleLimpar () {
      this.calendario = []
      this.filtro = {
        status: [],
        assunto: [],
        idsResponsaveis: [],
        dataInicio: moment().subtract(1, 'year').add(1, 'day').format('yyyy-MM-DD'),
        dataFim: moment().add(1, 'day').format('yyyy-MM-DD')
      }
      this.calendario[0] = moment().subtract(1, 'year').add(1, 'day').format('yyyy-MM-DD')
      this.calendario[1] = moment().add(1, 'day').format('yyyy-MM-DD')
      this.getRelatoriosPeriodo().then(() => this.seNaoHaDados())
    },

    tabSelecionado () {
      switch (this.activeTab) {
        case 'MENSAL':
          this.periodo = 'periodoMensal'
          this.seNaoHaDados()
          break
        case 'SEMANAL':
          this.periodo = 'periodoSemanal'
          this.seNaoHaDados()
          break
        case 'DIARIO':
          this.periodo = 'periodoDiario'
          this.seNaoHaDados()
          break
      }
    },

    async handleFiltrar () {
      if (
        this.calendario <= 0 ||
        this.filtro.dataInicio <= 0 ||
        this.filtro.dataFim <= 0) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Obrigatório um período nesta aba.'
        )
      } else if (
        !this.calendario <= 0 &&
        !this.filtro.status <= 0 &&
        !this.filtro.assunto <= 0 &&
        !this.filtro.idsResponsaveis <= 0
      ) {
        this.filtro.dataInicio = moment(this.calendario[0]).format('yyyy-MM-DD')
        this.filtro.dataFim = moment(this.calendario[1]).format('yyyy-MM-DD')
        const { mensal, semanal, diario } = await this.filtrarPorPeriodo(this.filtro)
        this.tabsPeriodos.abaMensal.dados = mensal
        this.tabsPeriodos.abaSemanal.dados = semanal
        this.tabsPeriodos.abaDiario.dados = diario
        this.seNaoHaDados()
        // primeiro, quantitativo mensal.
        const dataMensal = this.tabsPeriodos.abaMensal.dados
        let countMensal = 0
        for (let i = 0; i < dataMensal.length; i++) {
          countMensal += dataMensal[i].quantidade
        }
        this.tabsPeriodos.abaMensal.totalDeConversas = countMensal
        if (this.tabsPeriodos.abaMensal.totalDeConversas === 0) {
          this.tabsPeriodos.abaMensal.dados = []
        }
        // Segundo, quantitativo semanal.
        const dataSemanal = this.tabsPeriodos.abaSemanal.dados
        let countSemanal = 0
        for (let i = 0; i < dataSemanal.length; i++) {
          countSemanal += dataSemanal[i].quantidade
        }
        this.tabsPeriodos.abaSemanal.totalDeConversas = countSemanal
        if (this.tabsPeriodos.abaSemanal.totalDeConversas === 0) {
          this.tabsPeriodos.abaSemanal.dados = []
        }
        // Terceiro, quantitativo diário
        const dataDiario = this.tabsPeriodos.abaDiario.dados
        let countDiario = 0
        for (let i = 0; i < dataDiario.length; i++) {
          countDiario += dataDiario[i].quantidade
        }
        this.tabsPeriodos.abaDiario.totalDeConversas = countDiario
        if (this.tabsPeriodos.abaDiario.totalDeConversas === 0) {
          this.tabsPeriodos.abaDiario.dados = []
        }
      }
    },

    async getResponsaveis () {
      this.responsaveis = await this.findResponsaveis()
    },

    async getRelatoriosPeriodo () {
      const { mensal, semanal, diario } = await this.filtrarPorPeriodo(this.filtro)
      this.tabsPeriodos.abaMensal.dados = mensal
      this.tabsPeriodos.abaSemanal.dados = semanal
      this.tabsPeriodos.abaDiario.dados = diario
      const dataMensal = this.tabsPeriodos.abaMensal.dados
      let countMensal = 0
      for (let i = 0; i < dataMensal.length; i++) {
        countMensal += dataMensal[i].quantidade
      }
      this.tabsPeriodos.abaMensal.totalDeConversas = countMensal
      const dataSemanal = this.tabsPeriodos.abaSemanal.dados
      let countSemanal = 0
      for (let i = 0; i < dataSemanal.length; i++) {
        countSemanal += dataSemanal[i].quantidade
      }
      this.tabsPeriodos.abaSemanal.totalDeConversas = countSemanal
      const dataDiario = this.tabsPeriodos.abaDiario.dados
      let countDiario = 0
      for (let i = 0; i < dataDiario.length; i++) {
        countDiario += dataDiario[i].quantidade
      }
      this.tabsPeriodos.abaDiario.totalDeConversas = countDiario
    }
  },

  created () {
    this.assuntos = assuntos
    this.status = status
    this.calendario[0] = moment().subtract(1, 'year').add(1, 'day').format('yyyy-MM-DD')
    this.filtro.dataInicio = moment().subtract(1, 'year').add(1, 'day').format('yyyy-MM-DD')
    this.calendario[1] = moment().add(1, 'day').format('yyyy-MM-DD')
    this.filtro.dataFim = moment().add(1, 'day').format('yyyy-MM-DD')
  },

  mounted () {
    this.getResponsaveis()
    this.getRelatoriosPeriodo()
  }
}
</script>

<style lang="scss" scoped>

  .margin {
    margin: 1.5rem 2rem 1.5rem;
  }

  .margin-left {
    margin-left: 0.3rem;
  }

  .margin-bottom {
    margin-bottom: 30px;
    box-sizing: border-box;
  }

  .botaoExportar {
    margin: 1.5rem 2rem 0.5rem;
  }

  .center {
    display:flex;
    position:absolute;
    left: auto;
    right: 45%;
    top: -1.3rem;
  }

  .content-dados {
    margin-top: 1rem ;
    min-height: 22rem;
    max-height: auto;
    width: 100%;
  }

  /deep/ .cell {
    color: #424242;
  }

  /deep/ .el-tabs__nav-scroll {
    display: inherit;
  }

  .float {
    float: right;
  }

  .bolder {
    font-weight: bolder;
  }

  .center {
    display:flex;
    position:absolute;
    left: auto;
    right: 45%;
  }

  .container-tabela{
    display: flex;
    place-content: flex-end;
    margin-top: 80px;
  }

  .tabs {
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_ouvidoria/components/conversas/AppConversasPeriodo.vue